const cards = document.querySelectorAll(".explore-solutions-block");

function setActive(card) {
    cards.forEach(c => c.classList.remove("active"));
    card.classList.add("active");
}

cards.forEach(card => {

    // Card Hover
    card.addEventListener("mouseenter", () => {
        setActive(card);
    });

    // Card Click
    card.addEventListener("click", () => {
        setActive(card);
    });

    // Plus/Minus Button Click
    const btn = card.querySelector(".btn-block");

    if (btn) {
        btn.addEventListener("click", (e) => {
            e.stopPropagation(); // Parent click double fire na ho
            setActive(card);
        });
    }

});

// accordion
const accordions = document.querySelectorAll(".accordion");

accordions.forEach((item) => {

    item.querySelector(".accordion-header").addEventListener("click", () => {

        const isActive = item.classList.contains("active");

        // Close all
        accordions.forEach(acc => {
            acc.classList.remove("active");
            acc.querySelector(".icon").textContent = "+";
        });

        // Open clicked one
        if (!isActive) {
            item.classList.add("active");
            item.querySelector(".icon").textContent = "−";
        }

    });

});

  document.addEventListener('DOMContentLoaded', function() {
      var swiper = new Swiper('.whyUs--slider', {
          slidesPerView: 1,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
      });
  });